import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";

@Component({
  selector: "field-set-earlier-than",
  templateUrl: "./field-set-earlier-than.component.html",
  styles: [],
})
export class FieldSetEarlierThanComponent {

  @Input() public fieldOptions: any;
  @Output() public dataChanged = new EventEmitter();

  public dataChangedEvent(event) {
    this.dataChanged.emit(event);
  }
}
